import FundSavingsAccount from 'features/accounts/savings/FundSavingsAccount/FundSavingsAccount';
import React from 'react';

export default function Page() {
  return <FundSavingsAccount />;
}
